module.exports = __webpack_public_path__ + "static/img/Miles Oglethorpe.jpg";